"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var SmileyHappy = function SmileyHappy(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.055 8.47233C13.899 8.47233 14.5827 7.78866 14.5827 6.94466C14.5827 6.10133 13.899 5.41699 13.055 5.41699C12.211 5.41699 11.5273 6.10133 11.5273 6.94466C11.527 7.78866 12.2107 8.47233 13.055 8.47233Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.94368 8.47233C7.78768 8.47233 8.47135 7.78866 8.47135 6.94466C8.47135 6.10133 7.78768 5.41699 6.94368 5.41699C6.09968 5.41699 5.41602 6.10133 5.41602 6.94466C5.41602 7.78866 6.09968 8.47233 6.94368 8.47233Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.583 10C14.1613 10 13.819 10.3423 13.819 10.764C13.819 12.7633 11.9987 14.5833 9.99968 14.5833C8.00068 14.5833 6.18035 12.763 6.18035 10.764C6.18035 10.3423 5.83801 10 5.41635 10C4.99468 10 4.65234 10.3423 4.65234 10.764C4.65234 13.6127 7.15101 16.1113 9.99968 16.1113C12.8483 16.1113 15.347 13.6127 15.347 10.764C15.347 10.3423 15.0047 10 14.583 10Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM10 19C5.03733 19 1 14.9627 1 10C1 5.03733 5.03733 1 10 1C14.9627 1 19 5.03733 19 10C19 14.9627 14.9627 19 10 19Z"
  }));
};
var _default = exports["default"] = SmileyHappy;